import { httpClient } from '@/shared/api/http-client';
import { publicClient } from '@/shared/api/public-client';

// Public catalog endpoints (cached server-side with ETag + Cache-Control).
// Lists come back as Laravel paginators — we return the `data` array.

export async function listProducts(params = {}, signal) {
  const { data } = await publicClient.get('/products', { params, signal });
  return { items: data.data ?? [], meta: data.meta ?? null };
}

export async function getFeaturedProducts(signal) {
  const { data } = await publicClient.get('/products/featured', { signal });
  return data.data ?? [];
}

export async function getProduct(slug, signal) {
  const { data } = await publicClient.get(`/products/${slug}`, { signal });
  return data.data;
}

/** `[{ family, count }]` — live counts per olfactive family. */
export async function getCategories(signal) {
  const { data } = await publicClient.get('/categories', { signal });
  return data.data ?? [];
}

export async function getTestimonials(signal) {
  const { data } = await publicClient.get('/testimonials', { signal });
  return data.data ?? [];
}

/** Store contact + policy: shipping/COD/advance/bank details. */
export async function getStoreInfo(signal) {
  const { data } = await publicClient.get('/store-info', { signal });
  return data.data ?? {};
}

/** Approved reviews for a product. */
export async function getProductReviews(slug, signal) {
  const { data } = await publicClient.get(`/products/${slug}/reviews`, { signal });
  return data.data ?? [];
}

/** Submit a review (auth). Returns `{ message }`. */
export async function submitReview(slug, payload) {
  const { data } = await httpClient.post(`/products/${slug}/reviews`, payload);
  return data;
}

/** Freshness stamp for everything the storefront reads. Uncached by design. */
export async function getCatalogVersion(signal) {
  const { data } = await publicClient.get('/catalog-version', { signal });
  return data.version;
}
